import React, { Component } from 'react';
import {
    FormWrapper,
    FormColumn,
    FormGroup,
    FormControl,
    Button,
    ControlLabel
  } from 'modules/theme';

export class EndCallChangePwdTheme extends Component {

    renderFormGroup(label, props) {
        return (
          <FormGroup>
            <ControlLabel required={props.required}>{label}</ControlLabel>
            <FormControl {...props} />
          </FormGroup>
        );
      }


    render() {
        const {newPwd, confirmPwd, onDoneClick, ButtonText} = this.props;
        return (
            <span style={{display: 'block', width: '100%'}}>
                <form>
                    <FormWrapper>
                        {/* <FormColumn></FormColumn> */}
                        <FormColumn>
                            {this.renderFormGroup('New Password', {
                                defaultValue: '',
                                placeholder: 'password',
                                type: 'password',
                                autoFocus: false,
                                required: true,
                                id: 'comment',
                                value: this.props.newPwd,
                                onChange: e => {
                                    this.setState({ newPwd: e.target.value });
                                }
                            })}
                        </FormColumn>
                    </FormWrapper>
                    <FormWrapper>
                        {/* <FormColumn></FormColumn> */}
                        <FormColumn>
                            {this.renderFormGroup('Confirm Password', {
                                defaultValue: '',
                                placeholder: 'password',
                                type: 'password',
                                autoFocus: false,
                                required: true,
                                id: 'comment',
                                value: this.props.confirmPwd,
                                onChange: e => {
                                    this.setState({ confirmPwd: e.target.value });
                                }
                            })}
                        </FormColumn>
                    </FormWrapper>

                    <Button
                        onClick={onDoneClick}
                        btnStyle="default"
                        type="submit"
                        block
                        size="xl"
                    >
                        {ButtonText}
                    </Button>
                </form>
            </span>

        )
    }
}

export default EndCallChangePwdTheme


// WEBPACK FOOTER //
// ./src/modules/theme/theme1/common/components/EndCallChangePwdTheme.js